import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter)

import course_outline from "./modules/course_outline";

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/test',
      name: 'test',
      meta: { title: "测试" },
      component: () => import('@/pages/test.vue')
    },

    {
      path: '/org/success',
      name: 'org',
      meta: { title: "等级成功" },
      component: () => import('@/pages/org/success.vue')
    },
    {
      path: '/org/:orgID',
      name: 'org',
      meta: { title: "信息登记表" },
      component: () => import('@/pages/org/index.vue')
    },
    {
      path: '/news',
      name: 'news',
      meta: { title: "行业动态" },
      component: () => import('@/pages/news/index.vue')
    },
    ...course_outline
  ]
});


// https://www.cnblogs.com/zyulike/p/11190012.html
// https://www.cnblogs.com/maxiansheng/articles/11289355.html
